export var HexFileKeys = {
    alertDetailsGet: "alertDetailsGet",
    upsertHexFileAlert: "upsertHexFileAlert",
    checkHexFile: "checkHexFile",
    reasonList: "reasonList",
    systemName: "AlertDetail",
    skipOptionCondition: "skipOptionCondition"
};
